import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { PhoneNumberEditor } from '@components/PhoneNumberEditor';
import { updateUserPhone } from '@containers/Admin/containers/UserPage/actions';

export const EditPhoneNumber = () => {
  const dispatch = useDispatch();
  const saving = useSelector(
    (state: RootStateOrAny) => state.getIn(['userPage', 'phoneUpdateLoading']),
  );
  const saveRevision = useSelector(
    (state: RootStateOrAny) => state.getIn(['userPage', 'phoneUpdateRevision']),
  );
  const userData = useSelector(
    (state: RootStateOrAny) => state.getIn(['userPage', 'userData']),
  );
  const { id, phone, mfaStatus } = userData || {};

  return <PhoneNumberEditor
    userId={id}
    phone={phone}
    mfaStatus={mfaStatus}
    saving={Boolean(saving)}
    saveRevision={saveRevision}
    onSave={(userId, phoneNumber) => dispatch(updateUserPhone(userId, phoneNumber))}
  />;
};